import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 


const ArtkworkList = lazy(() => import("../pages/artwork/artworkList"));

const AddImpactAssessment = lazy(() => import("../pages/artwork/wizard/index"));



const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/artwork" />
    ),
  },
  {
    path: "/artwork",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ArtkworkList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
 
  {
    path: "artwork/add-impactassessment",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddImpactAssessment />
        </Suspense>
      </ErrorBoundary>
    ),
  },

  
];

const Router = createBrowserRouter(routesForm);

export { Router };